import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.25),
  },
  metaLabel: {
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.text.secondary,
  },
  errorText: {
    color: theme.palette.error.main,
  },
  emptyStateContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    // padding: '12px',
    // paddingLeft: '24px',
    // backgroundColor: theme.palette.backgroundV2.light,
  },
  emptyStateText: {
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.textField.main,
  },
  createButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  createIcon: {
    fontSize: 14,
  },
}))
